import { format } from "date-fns";
import { Card, Icon, Typography } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../../common/DetailField";

interface ActualLandingTimeCardProps {
  booking: BookingDetails;
}

export const ActualLandingTimeCard = ({ booking }: ActualLandingTimeCardProps) => {
  const flightDetails = booking.stops.find((stop) => stop.flight)?.flight;

  const formatLandingTime = () => {
    if (!flightDetails?.arrival.actual) return "-";

    try {
      const date = new Date(flightDetails.arrival.actual);
      return format(date, "dd MMM yyyy (EEE), h:mm a");
    } catch {
      return "-";
    }
  };

  const getFlightInfo = () => {
    if (!flightDetails?.number) return "Flight information not available";

    const parts = [];
    if (flightDetails.airline) parts.push(flightDetails.airline.name);
    if (flightDetails.number) parts.push(`(${flightDetails.number})`);
    if (flightDetails.arrival.terminal) parts.push(`- Terminal ${flightDetails.arrival.terminal}`);

    return parts.join(" ");
  };

  const flightValue = (
    <div>
      <Typography variant="paragraph">{getFlightInfo()}</Typography>
      <Typography variant="paragraph">{formatLandingTime()}</Typography>
    </div>
  );

  if (!flightDetails) return null;

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="Timer1" size="lg" className="text-neutral-dark-gray" />}
        label="Actual Landing Time"
        value={flightValue}
      />
    </Card>
  );
};
